export default "__VITE_ASSET__DFcPuBWd__"